export const imageTypes = ['tif', 'tiff', 'bmp', 'jpg', 'jpeg', 'gif', 'png'];
export const defaultImagePlaceholder = 'assets/svg/building_placeholder.svg';
